import React, { lazy, Suspense } from "react";

import LoadSkeleton from "../loadSkeleton";

const LazyEditor = lazy(() => import("./editor"));

const TextEditor = ({
  label,
  labelCol,
  required,
  wrapperCol,
  onSetContent,
  initialValue,
  formItemLayout,
}) => (
  <Suspense fallback={<LoadSkeleton />}>
    <LazyEditor
      label={label}
      labelCol={labelCol}
      required={required}
      wrapperCol={wrapperCol}
      onSetContent={onSetContent}
      initialValue={initialValue}
      formItemLayout={formItemLayout}
    />
  </Suspense>
);

export default TextEditor;
